import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[optional]',
  standalone: true,
})
export class OptionalLabelDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    const label = this.el.nativeElement;
    const span = document.createElement('span');
    span.className = 'text-500 font-normal text-sm';
    span.textContent = ' (opcional)';
    label.appendChild(span);
  }
}
